import { Breadcrumbs } from 'AbstractElements';
import QuestionContain from 'Component/Learning/BankQuestion/QuestionsPost';
import { useSelector } from 'react-redux';

const QuestionPost = () => {
    const isUpdate = useSelector(state => state.addQuestion.isUpdate);

    return (
        <>
            <Breadcrumbs grandparent="Learning" parent="Bank Soal" title={isUpdate ? 'Update Soal' : 'Tambah Soal'} />
            <QuestionContain />
        </>
    );
};

export default QuestionPost;